import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import * as classes from "../styles/header.module.scss";
import { Icon } from "../components/Icon";
import { motion } from "framer-motion";
import clsx from "clsx";
import { DesktopMenu } from "./menu/desktopMenu";
import { MobileMenu } from "./menu/mobileMenu";
import { SearchDialog } from "./menu/searchDialog";
import useDimensions from "../hooks/useDimensions";
import { useQuery } from "urql";
const logoIcon = new URL("../assets/logo.svg", import.meta.url);
const HlIcon = new URL("../assets/highlight.svg", import.meta.url);
import { GET_MENU_DATA } from "../queries/getMenuData.gql";
import { ControlledMenu, MenuItem } from "@szhsin/react-menu";
import { useHeaderStore } from "../hooks/useHeaderStore";
import Mask from "./Mask";
import { Query } from "../queries/graphql";

export type AppModalType =
  | "men"
  | "women"
  | "mobile"
  | "search"
  | "cart"
  | "about"
  | "buy1get1"
  | "none";
export const Header = () => {
  const [{ data, fetching, error }, executeQuery] = useQuery<Query>({
    query: GET_MENU_DATA,
  });
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const menItems = useMemo(() => {
    return data?.CMS.siteMenu.MenMenu.items ?? [];
  }, [data?.CMS.siteMenu.MenMenu.items]);
  const womenItems = useMemo(() => {
    return data?.CMS.siteMenu.WomenMenu.items ?? [];
  }, [data?.CMS.siteMenu.WomenMenu.items]);
  // cart data
  const aboutBtnRef = useRef();
  const [headerRef, dimensions, node] = useDimensions({ liveMeasure: true });
  const setShowMenu = useHeaderStore((state) => state.setModal);
  const showMenu = useHeaderStore((state) => state.modal);

  return (
    <>
      <div className={classes.root} ref={headerRef}>
        <div className={classes.leftArea}>
          <div className={classes.navItem}>
            <button
              className={classes.menuButton}
              onClick={() => {
                setShowMenu("mobile");
              }}
            >
              <Icon classes={{ root: classes.menuIcon }} name="menu"></Icon>
            </button>
          </div>
        </div>
        <div className={classes.leftAreaDesktop}>
          <button
            className={classes.navItemDesktop}
            onClick={() => {
              setShowMenu("men");
            }}
            onMouseOver={() => {
              setShowMenu("men");
            }}
          >
            <span>Nam giới</span>
            {showMenu == "men" && (
              <motion.img
                layoutId="bottomHl"
                className={classes.hlIcon}
                alt="hl"
                src={HlIcon.toString()}
              ></motion.img>
            )}
          </button>
          <button
            className={classes.navItemDesktop}
            onClick={() => {
              setShowMenu("women");
            }}
            onMouseOver={() => {
              setShowMenu("women");
            }}
          >
            <span>Nữ giới</span>
            {showMenu == "women" && (
              <motion.img
                layoutId="bottomHl"
                className={classes.hlIcon}
                alt="hl"
                src={HlIcon.toString()}
              ></motion.img>
            )}
          </button>
          <button
            className={classes.navItemDesktop}
            onMouseOver={() => {
              setShowMenu("about");
            }}
            ref={aboutBtnRef}
          >
            <span>Về curnon</span>
            {showMenu == "about" && (
              <motion.img
                layoutId="bottomHl"
                className={classes.hlIcon}
                alt="hl"
                src={HlIcon.toString()}
              ></motion.img>
            )}
          </button>
        </div>
        <div className={classes.logoArea}>
          <a href="/">
            <img
              src={logoIcon.toString()}
              className={classes.logo}
              alt="curnon logo"
            ></img>
          </a>
        </div>
        <div className={classes.rightArea}>
          {/* <div className={classes.navItem}>
            <button
              className={clsx(classes.navItem)}
              onClick={() => {
                //open search modal
                setShowMenu("search");
              }}
            >
              <span>
                <Icon
                  name="search"
                  classes={{ root: classes.searchIcon }}
                ></Icon>
              </span>
            </button>
          </div> */}
          {/* <button
            className={classes.navItem}
            onClick={() => {
              setShowMenu("cart");
            }}
          >
            <span>
              <Icon classes={{ root: classes.cartIcon }} name="cart"></Icon>
              {hasItem && (
                <span className={classes.cartActiveDot}>
                  {cartState.details?.items?.length}
                </span>
              )}
            </span>
          </button> */}
        </div>
        <div className={classes.rightAreaDesktop}>
          {/* <button
            className={classes.navItemDesktop}
            onClick={() => {
              setShowMenu("cart");
            }}
          >
            <span>
              <span>Giỏ hàng</span>
              <span style={{ position: "relative", paddingLeft: 10 }}>
                <Icon classes={{ root: classes.cartIcon }} name="cart"></Icon>
                {hasItem && (
                  <span className={classes.cartActiveDot}>
                    {cartState.details?.items?.length}
                  </span>
                )}
              </span>
            </span>
          </button> */}

          {/* <button
            className={clsx(classes.navItemDesktop)}
            onClick={() => {
              //open search modal
              setShowMenu("search");
            }}
          >
            <span>
              <Icon name="search" classes={{ root: classes.searchIcon }}></Icon>
            </span>
          </button> */}
        </div>

        <DesktopMenu
          key="men-menu"
          menuData={showMenu == "men" ? menItems : womenItems}
          isOpen={showMenu == "women" || showMenu == "men"}
          closeModal={() => setShowMenu("none")}
          dimensions={dimensions}
        ></DesktopMenu>

        <MobileMenu
          key="mobile-menu"
          menuData={data?.CMS.siteMenu}
          isOpen={showMenu == "mobile"}
          closeModal={() => setShowMenu("none")}
        ></MobileMenu>
        {/* <SearchDialog
          isOpen={showMenu == "search"}
          closeModal={() => setShowMenu("none")}
          dimensions={dimensions}
        ></SearchDialog> */}
      </div>
      <ControlledMenu
        isOpen={isMounted && showMenu == "about"}
        onClose={() => {
          setShowMenu("none");
        }}
        direction={"bottom"}
        align="center"
        anchorRef={aboutBtnRef}
        className={classes.aboutMenu}
      >
        <MenuItem className={classes.aboutMenuItem}>
          <a href="/blog" className={classes.aboutMenuItemLink}>
            Blog
          </a>
        </MenuItem>
        <MenuItem className={classes.aboutMenuItem}>
          <a href="/about" className={classes.aboutMenuItemLink}>
            Về chúng tôi
          </a>
        </MenuItem>
        <MenuItem className={classes.aboutMenuItem}>
          <a
            href="https://longandshort.vn"
            className={classes.aboutMenuItemLink}
            target="_blank"
          >
            Long & Short
          </a>
        </MenuItem>
      </ControlledMenu>
      <Mask
        isActive={showMenu == "about"}
        classes={{ root: classes.maskRoot }}
        dismiss={() => {
          setShowMenu("none");
        }}
        delayedDismiss={() => {
          setTimeout(() => setShowMenu("none"), 350);
        }}
      />
    </>
  );
};
